<template>
  <v-container fluid>
    <material-card icon="mdi-clipboard-text" inline title="Center Wise Audits">
      <!-- <v-btn class="add-audit-offline"
        v-on:click="()=>{$router.push({ name: 'addAudit', params: {type: 'online'} })}"
        v-if="isWrite" elevation="1" :class="{ 'mt-2': $vuetify.breakpoint.xs }" color="accent">
        <v-icon left>mdi-plus</v-icon>
        Start New Audit
      </v-btn> -->
      <!-- <v-btn class="add-audit-online" v-on:click="()=>{$router.push({ name: 'auditDrafts'})}"
        v-if="isWrite" elevation="1" :class="{ 'mt-2': $vuetify.breakpoint.xs }" color="accent">
        View Drafts
      </v-btn> -->
      <a @click="$router.back()">
        <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top>
          <v-icon left>mdi-arrow-left</v-icon>back
        </v-btn>
        <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10"
          style="opacity:.6;">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </a>
      <v-card-component>
        <!--Filter header start -->
        <v-row>
          <!-- <v-col class="mt-2" sm="3">
            <v-text-field
              :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
              v-model="search" append-icon="mdi-magnify" class="ml-auto mb-2" label="Search"
              hide-details single-line style="max-width:350px;" />
          </v-col> -->
          <v-col cols="12" md="4">
            <!-- <label class="font-weight-medium body-2">
                Select Centers
                <span class="requir error--text">*</span>
              </label> -->
            <v-autocomplete class="mt-3" label="Center" v-model="franchiseeID"
              @change="getFranchisee()" clearable :items="franchiseeOptions" key="id"
              item-value="id" item-text="companyName">
            </v-autocomplete>
          </v-col>
          <!-- <v-col cols="12" md="4">
            <v-btn @click="getFranchisee()" color="success" class="px-2 ml-1 ma-1 mt-4">
              <v-icon small> mdi-magnify </v-icon> Search
            </v-btn>
          </v-col> -->
        </v-row>
        <!--Filter header end -->
        <!--Data table start -->
        <v-data-table :headers="headers" :items="centreList" disable-pagination hide-default-footer>

          <template v-slot:item.actions="{ item }">
            <v-btn color="success" class="px-2 ml-1 ma-1" min-width="0" small
              v-on:click="()=>{$router.push({ name: 'individualCentreList', params: {id: item.FranchiseeName[0].id} })}">
              <v-icon small> mdi-eye </v-icon>
            </v-btn>
          </template>

          <template v-slot:no-data>
            <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
          </template>
        </v-data-table>
        <!--Data table end -->
        <!--Pagination start-->
        <v-row>
          <v-col cols="4" sm="3">
            <v-select v-model="pageSize" :items="pageSizes" label="Items per Page"
              @change="handlePageSizeChange"></v-select>
          </v-col>
          <v-col cols="12" sm="9">
            <v-pagination v-model="page" :length="totalPages" :total-visible="totalPages"
              @input="handlePageChange">
            </v-pagination>
          </v-col>
        </v-row>
        <!--Pagination end-->
      </v-card-component>
    </material-card>
  </v-container>
</template>

<script>
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'
import constants from '@/utils/constants'
import { mapGetters } from 'vuex'
import moment from 'moment'
// import moment from 'moment'

export default {
  components: { VCardComponent, MaterialCard },
  async created () {
    this.getFranchisee()
    this.getfranchiseeOptions()
  },
  watch: {
    franchisee: async function (val) {
      this.franchiseeID = val.id
      this.getFranchisee()
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  data () {
    return {
      auditData: [],
      franchiseeID: '',
      centreList: [],
      franchiseeOptions: [],
      page: 1,
      pageSize: 10,
      pageSizes: [5, 10, 20],
      totalPages: 0,
      search: '',
      isWrite: true,
      academicYearID: '',
      headers: [
        { text: 'Center', value: 'FranchiseeName[0].companyName', sortable: true },
        // { text: 'Audits Completed', value: 'auditeeDetails', sortable: true },
        { text: 'Last audited on', value: 'auditDate', sortable: true },
        { text: 'Actions', value: 'actions', align: 'center', sortable: false }
      ]
    }
  },
  methods: {
    getFranchisee: async function () {
      try {
        this.isLoading = true
        let res = await http.get(`${constants.API_URL}/api/center-audit/audit/centerlist`, {
          params: {
            page: this.page - 1,
            size: this.pageSize,
            franchiseeID: this.franchiseeID,
            search: this.search
          }
        })
        this.centreList = res.data.rows.map((item) => {
          item.auditDate = moment(item.auditDate).format('MMM Do YYYY')
          return item
        })
        console.log(this.centreList)
        this.totalPages = Math.ceil(res.data.totalItems.length / this.pageSize)
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    getfranchiseeOptions: async function () {
      try {
        const response = await http.get(`${constants.API_URL}/api/franchisee/active`)
        const data = response.data

        if (data.rows.length > 1) {
          this.franchiseeOptions = [{ id: '', companyName: 'Select All' }].concat(data.rows)
        } else {
          this.franchiseeOptions = data.rows
        }
      } catch (e) {
        console.log(e)
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    handlePageChange: function () {
      console.log(`Page: ${this.page}`)
      this.getFranchisee()
    },
    handlePageSizeChange: function () {
      console.log(`Page Size: ${this.pageSize}`)
      this.getFranchisee()
    },
    okMsg (msg) {
      return this.$buefy.dialog.alert({
        type: 'is-success',
        message: msg,
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  }
}
</script>

<style scoped>
.add-audit-offline {
  position: absolute;
  right: 150px;
  top: 18px;
}
.add-audit-online {
  position: absolute;
  right: 350px;
  top: 18px;
}
</style>
